'use strict';

import { getVueTemplate } from '../../_imports/utils/utils.common';
import Modal from '../modal.vue';
import MarketoForm from '../../forms/_imports/marketo-form.vue';
import BaseVueComponent from "../../_imports/shared/base-vue-component.vue.common";

export default {
	name: 'modal-with-form',
	template: getVueTemplate('modal-with-form'),
	mixins: [
		BaseVueComponent
	],
	components: {
        Modal,
		MarketoForm
	}
};